import React from 'react';
import { useCensusFiltersContext } from '../Common/Filters/hooks/useCensusFiltersContext';
import OverviewCards from './OverviewCards';

const Panorama = () => {
    const { filters } = useCensusFiltersContext();
    const cityId = filters.cidade?.value;

    if (!cityId) {
        return <div className="censo-notice">Selecione uma cidade para ver o panorama do Censo.</div>;
    }

    return <OverviewCards cityId={cityId} year={filters.year?.value} />;
};

export default Panorama;
